<template>
  <v-row>
    <v-col cols="12">
      <v-row class="elevation-3 pl-4 wz_table_header" no-gutters>
        <h2 class="pb-4 pt-4">User roles</h2>
      </v-row>
      <v-data-table :headers="headers" :items="roles" class="wz_data_table elevation-2">
        <template v-slot:[`item.actions`]="{ item }">
          <edit-role-button :role="item" />
          <edit-permissions-button :roleId="item.roleId" />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import EditRoleButton from './EditRoleButton.vue';
import EditPermissionsButton from "./EditPermissionsButton.vue";

export default {
  components: { EditRoleButton, EditPermissionsButton },
  data: () => ({
    headers: [
      { text: "Role name", align: "start", value: "name" },
      { text: "Description", value: "description" },
      { text: "Actions", value: "actions", sortable: false, width: "50px" },
    ],
  }),
  computed: {
    ...mapState("roles", ['roles', 'permissions']),
  },
};
</script>
